import api from 'services/api.service';

const resource = '/db';

export const find = ({ tableName, matchQuery, isQuery = [] }) => api
  .post(`${resource}/find`, { tableName, matchQuery, isQuery });

export const insertOne = ({ tableName, entity }) => api
  .post(`${resource}/insert-one`, { tableName, entity });

export const insertMany = ({ tableName, entities }) => api
  .post(`${resource}/insert-many`, { tableName, entities });

export const publicSelect = ({ selectKey, params }) => api
  .post(`${resource}/public-select`, { selectKey, params });

export const remove = ({ tableName, matchQuery }) => api
  .post(`${resource}/remove`, { tableName, matchQuery });

export const select = ({ selectKey, params }) => api
  .post(`${resource}/select`, { selectKey, params });

export const updateOne = ({ tableName, matchQuery, validatedUpdate }) => api
  .post(`${resource}/update-one`, { tableName, matchQuery, validatedUpdate });





